import React, { Component } from 'react';

class PDFViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      iframeLoaded: false
    };
  }

  componentDidMount() {
    // Add event listener for iframe load
    this.iframe.addEventListener('load', this.handleIframeLoad);
  }

  componentWillUnmount() {
    // Remove event listener when component unmounts
    this.iframe.removeEventListener('load', this.handleIframeLoad);
  }

  handleIframeLoad = () => {
    // Once iframe is loaded, render the PDF inside it
    this.renderPDFInIframe();
    this.setState({ iframeLoaded: true });
  };

  renderPDFInIframe() {
    const { src } = this.props;

    // Create a new iframe document
    const doc =
      this.iframe.contentDocument || this.iframe.contentWindow.document;

    // Generate HTML content with embed tag for PDF
    const embedHtml = `<html><body style="margin: 0;"><embed src="${src}" type="application/pdf" style="width: 100%; height: 100%;" /></body></html>`;

    // Write the HTML content to the iframe document
    doc.open();
    doc.write(embedHtml);
    doc.close();
  }

  render() {
    const { iframeLoaded } = this.state;
    return (
      <iframe
        ref={(iframe) => (this.iframe = iframe)}
        style={{
          width: '100%',
          height: '500px',
          border: '0',
          display: iframeLoaded ? 'block' : 'none'
        }}
      />
    );
  }
}

export default PDFViewer;
